import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Dictamen} from '../../../domain/dictamen';
import {CategoriaDictamenService} from '../../../service/categoria-dictamen.service';
import {DictamenService} from '../../../service/dictamen.service';
import {SelectItem} from 'primeng/components/common/api';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageSeverity} from 'app/core/commons/message-severity';
import {GlobalAppService} from 'app/core/commons/global-app.service';

@Component({
    selector: 'app-dictamenes-form',
    templateUrl: './dictamenes-form.component.html',
    styleUrls: ['./dictamenes-form.component.scss'],
    providers: [CategoriaDictamenService, DictamenService],
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class DictamenesFormComponent implements OnInit {

    dictamenForm: FormGroup = null;
    update = false;
    newFile = false;
    fileName = '';
    title = '';
    dictamen: Dictamen = null;
    categorias: SelectItem[] = [{ label : 'Selecciona una opcion', value: null }];
    file: File[] = [];

    constructor(
        private formBuilder: FormBuilder,
        private categoriaService: CategoriaDictamenService,
        private dictamenService: DictamenService,
        private messageService: GlobalAppService,
        private route: ActivatedRoute,
        private router: Router,
        // private cd: ChangeDetectorRef
    ) {}

    ngOnInit() {

        this.dictamenForm = this.formBuilder.group({
            name : ['', Validators.required],
            keywords : ['', Validators.required],
            category : ['', Validators.required]
        });

        const id = this.route.params
            .map(params => params['id']);

        id.filter(id => id !== 'new')
            .switchMap(id => this.dictamenService.get(+id))
            .subscribe(dictamen => {
                this.title = 'Edición del dictamen';
                this.dictamen = dictamen;
                this.fileName = this.dictamen.name.replace(' ', '-');
                this.fileName = this.fileName + '.pdf';
                this.dictamenForm.get('name').setValue(this.dictamen.name);
                this.dictamenForm.get('category').setValue(this.dictamen.category);
                this.dictamenForm.get('keywords').setValue(this.dictamen.keywords);
                this.update = true;
                // this.cd.markForCheck();
                });

        id.filter(id => id === 'new')
            .subscribe(id => {
                this.dictamen = new Dictamen();
                this.title = 'Nuevo dictamen';
                // this.cd.markForCheck();
            });

        this.categoriaService.getAll()
            .map( categoria =>
                    categoria.map( c => ({ label : c.name, value: { id : c.id, name: c.name } }) )
            )
            .subscribe(categorias => {
                this.categorias = this.categorias.concat(categorias);
                // this.cd.markForCheck();
            });
    }

    public downloadDictamen( event ) {
        event.preventDefault();
        this.dictamenService.downloadPDF(this.dictamen.id.toString())
            .subscribe(res => {
                const fileURL = URL.createObjectURL(res);
                const downloadLink = document.createElement('a');
                downloadLink.href = fileURL;
                downloadLink.download = this.dictamen.getFileName();
                downloadLink.click();
                // this.cd.markForCheck();
            });
    }

    public validDictamen(): boolean {

        if ( !this.update && this.newFile ) {
            return true;
        }
        if ( this.update ) {
            return true;
        }
        return false;
    }

    public newFileSelected ( value: boolean){
        this.newFile = value;
    }

    public onSubmit( { value, valid } ) {
        if ( valid ) {
            if ( !this.update ) {
                this.dictamen = new Dictamen(value);
                this.dictamenService.create(this.dictamen).subscribe(d => {
                    this.messageService.sendMsg(MessageSeverity.SUCCESS, 'Nuevo dictamen', 'El dictamen se creo con exito.');
                    this.dictamenService.uploadPDF(this.file[0], d.id.toString())
                        .subscribe(
                            error => console.log(error)
                        );
                    this.router.navigate(['home', 'dictamenes']);
                });
            } else {
                const d = new Dictamen(value);
                d.id = this.dictamen.id;
                this.dictamenService.update(d).subscribe(d => {
                    this.messageService.sendMsg(MessageSeverity.SUCCESS, 'Dictamen modificado', 'El dictamen se modifico con exito.');
                    if (this.newFile)
                        this.dictamenService.uploadPDF(this.file[0], d.id.toString())
                        .subscribe(
                            error => console.log(error)
                        );
                    this.router.navigate(['home', 'dictamenes']);
                });
            }
        }
    }

    public goBack() {
        this.router.navigate(['home', 'dictamenes']);
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/dictamenes/dictamenes-form/dictamenes-form.component.ts